

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const LOGINAUTHUSER= createAsyncThunk(
  "loginAuthUser/loginAuthUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const loginAuthUserSlice = createSlice({
  name: "loginAuthUserSlice",
  initialState: {
    loginAuthUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfloginAuthUser: (state) => {
        state.loginAuthUser.loading = false
        state.loginAuthUser.error = false
        state.loginAuthUser.data = []
        state.loginAuthUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(LOGINAUTHUSER.fulfilled, (state, action) => {
      state.loginAuthUser = {
        ...state.loginAuthUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LOGINAUTHUSER.pending, (state, action) => {
      state.loginAuthUser = {
        ...state.loginAuthUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LOGINAUTHUSER.rejected, (state, action) => {
      state.loginAuthUser = {
        ...state.loginAuthUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const loginAuthUserAction = {
    LOGINAUTHUSER,
};

export { loginAuthUserAction };
export default loginAuthUserSlice.reducer;
export const {setInitialStateOfloginAuthUser} = loginAuthUserSlice.actions
